import React, { FunctionComponent } from 'react'
import styles from './Overlay.module.css'

type Props = {
  onClick?: () => void
  testId?: string
}

export const Overlay: FunctionComponent<Props> = ({
  onClick = undefined,
  testId = undefined,
}: Props) => (
  <div data-testid={testId} onClick={onClick} className={styles.Overlay} />
)

export default Overlay
